import { useQuery } from "react-query";
import http from "infra/http";
import { Perfil } from "../typings";

function useGetPerfil(id?: string | null) {
  return useQuery(
    [`/v1/perfil/${id}`, id],
    async () => {
      const { data } = await http.get<Perfil>(`/v1/perfil/${id}`);

      return data;
    },
    { enabled: !!id }
  );
}

export default useGetPerfil;
